import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { getApiBaseUrl } from '@/legacy/data/apiHelpers';
import { startReplayPrivacyGuard } from '@/lib/observability/replayPrivacyGuard';
import { RUM_PRIVACY_CONFIG } from '@/lib/observability/rumPrivacy';

// Imported before the router module so the replay guard's popstate listener is
// registered ahead of React Router's, which starts views synchronously.

const BASE_API_TRACING_URL = getApiBaseUrl();

datadogRum.init({
  applicationId: import.meta.env.VITE_DATADOG_APP_ID,
  clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  site: 'us5.datadoghq.com',
  service: `portal-${import.meta.env.VITE_AUTH0_ORG_ID ?? 'primary'}`,
  env: import.meta.env.VITE_AWS_BRANCH ?? 'dev',
  version: import.meta.env.VITE_AWS_COMMIT_ID ?? 'unknown',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  // https://docs.datadoghq.com/tracing/other_telemetry/rum/?tab=browserrum
  allowedTracingUrls:
    BASE_API_TRACING_URL.includes('localhost') ||
    BASE_API_TRACING_URL.includes('127.0.0.1')
      ? []
      : [{ match: BASE_API_TRACING_URL, propagatorTypes: ['datadog'] }],
  traceSampleRate: 10,
  trackViewsManually: true,
  plugins: [reactPlugin({ router: true })],
  ...RUM_PRIVACY_CONFIG,
});
startReplayPrivacyGuard(datadogRum);
